// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import { defaultContext, QueryClient, QueryClientProvider } from '/Users/yangkang/Desktop/streams-admin/node_modules/.pnpm/@tanstack+react-query@4.36.1_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/@tanstack/react-query';
import { ReactQueryDevtools } from '/Users/yangkang/Desktop/streams-admin/node_modules/.pnpm/@tanstack+react-query-devtools@4.36.1_@tanstack+react-query@4.36.1_react-dom@18.2.0_react@18._5uflqywsfhy5f6th3mfp5laasq/node_modules/@tanstack/react-query-devtools';
const reactQueryConfig = {};
const client = new QueryClient(reactQueryConfig.queryClient || {});
export function rootContainer(container) {
  return (
    <QueryClientProvider client={client} context={defaultContext}>
      {container}
      <ReactQueryDevtools context={defaultContext} initialIsOpen={false} {...(reactQueryConfig.devtool || {})} />
    </QueryClientProvider>
  );
}
